import routes from '@/config/routes';
import type { AxiosResponse } from 'axios';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import type { ApiResponse } from '../types';
import type {
  IPermissionAndGroupPost,
  IUserPermissionGroupRequest,
  IUserPermissionPermissionRequest,
  IUserPermissionRequest,
} from '@/store/admin/types/types';

const getUserListByTypes = (typeIds: string): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.getUserListByTypes}/${typeIds}/list`);

const getUserPermission = (request: IUserPermissionRequest): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.getUserPermissionList}/${request.clientId}/user/${request.userId}/list`);

const getUserPermissionGroup = (request: IUserPermissionRequest): ApiResponse =>
  v3Get(
    `${routes.backendUrl.permissionAdmin.getUserPermissionGroupList}/${request.clientId}/user/${request.userId}/list`,
  );

const getUserPermissionGroupByClientAndGroupId = (request: IUserPermissionGroupRequest): ApiResponse =>
  v3Get(
    `${routes.backendUrl.permissionAdmin.permission}/user/client/${request.clientId}/group/${request.groupId}/list`,
  );

const getUserPermissionByClientAndPermissionId = (request: IUserPermissionPermissionRequest): ApiResponse =>
  v3Get(
    `${routes.backendUrl.permissionAdmin.permission}/user/client/${request.clientId}/permission/${request.permissionId}/list`,
  );

const savePermissionWithGroup = async (permissions: IPermissionAndGroupPost): Promise<AxiosResponse> => {
  return await v3Post(
    `${routes.backendUrl.permissionAdmin.setUserPermissionAndGroup}/${permissions.clientId}/user/${permissions.userId}/group/set`,
    permissions,
  );
};

export const userPermissionAdminApi = {
  getUserListByTypes,
  getUserPermission,
  getUserPermissionGroup,
  savePermissionWithGroup,
  getUserPermissionGroupByClientAndGroupId,
  getUserPermissionByClientAndPermissionId,
};
